import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/common/popMotion.css';
import App from './App';
import { ConfigProvider } from './context/ConfigContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ConfigProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ConfigProvider>
);
